module.exports = __webpack_public_path__ + "static/worley-logo-d52e8fee9e34d295bba06d0447fc91e3.jpg";